export const visitorPurposeTableKeys = [
  {
    name: "Name",
    key: "name",
  },
  {
    name: "Description",
    key: "description",
  },
];
